import React from "react";
import { Container, FormFeedback, Input, Row, Col, Form } from "reactstrap";
import { Link, useNavigate, useSearchParams  } from "react-router-dom";
import { resetForgotenPassword } from "../../slices/thunks";

//redux
import { useDispatch } from "react-redux";

//import images
import logolight from "../../assets/images/khozi.png";
import logoDark from "../../assets/images/khozi.png";
import { useFormik } from "formik";
import * as Yup from "yup";

const ForgotPassword1 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  document.title = "Forgot Password | Khozi";

  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");


  const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
          newpassword: "",
          confirmpassword: ""
        },
        validationSchema: Yup.object({
          newpassword: Yup.string()
            .min(6, "A palavra-passe deve ter pelo menos 6 caracteres")
            .required("Por favor introduza a sua nova palavra-passe"),
          confirmpassword: Yup.string()
            .oneOf([Yup.ref("newpassword"), null as any], "As palavras-passe não coincidem")
            .required("Por favor confirme a sua nova palavra-passe"),
        }),
        onSubmit: (values, { setSubmitting }) => {
          setSubmitting(true);
          dispatch(resetForgotenPassword(token, values.newpassword, navigate)).then(() => {
            setSubmitting(false);
          });
        },
    }); 
  
  return (
    <React.Fragment>
      <div className="authentication-bg min-vh-100">
        <div className="bg-overlay bg-white"></div>
        <Container>
          <div className="d-flex flex-column min-vh-100 px-3 pt-4">
            <Row className=" justify-content-center my-auto">
              <Col md={8} lg={6} xl={4}>
                <div className="text-center py-5">
                  <div className="mb-4 mb-md-5">
                    <Link to="/control-panel" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="120" className="auth-logo-dark"/>
                      <img src={logolight} alt="" height="120" className="auth-logo-light"/>
                    </Link>
                  </div>
                  <div className="text-muted mb-4">
                    <h5 className="">Esqueceu a sua palavra-passe?</h5>
                  </div>
                  <Form
                    onSubmit={e => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="form-floating form-floating-custom text-start mb-3">
                      <Input 
                        name="newpassword"
                        type="password" 
                        className="form-control" 
                        id="input-newpassword" 
                        placeholder="Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.newpassword || ""}
                        invalid={
                          validation.touched.newpassword &&
                          validation.errors.newpassword ? true : false
                        }                        
                        />
                        {validation.errors.newpassword ? (
                        <FormFeedback type="invalid">
                          {validation.errors.newpassword}
                        </FormFeedback>
                      ) : null}
                      <label htmlFor="input-newpassword">
                        Nova palavra-passe
                      </label>
                      <div className="form-floating-icon">
                        <i className="uil uil-padlock"></i>
                      </div>
                    </div>
                    <div className="form-floating form-floating-custom text-start mb-3">
                      <Input
                        name="confirmpassword"
                        type="password"
                        className="form-control"
                        id="input-confirmpassword"
                        placeholder="Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.confirmpassword || ""}
                        invalid={
                          validation.touched.confirmpassword &&
                          validation.errors.confirmpassword ? true : false
                        }
                      />
                      {validation.touched.confirmpassword &&
                      validation.errors.confirmpassword ? (
                        <FormFeedback type="invalid">
                          {validation.errors.confirmpassword}
                        </FormFeedback>
                      ) : null}
                      <label htmlFor="input-confirmpassword">
                        Confirmar palavra-passe
                      </label>
                      <div className="form-floating-icon">
                        <i className="uil uil-check-circle"></i>
                      </div>
                    </div>

                    <div className="mt-3">
                      <button className="btn btn-info w-100" type="submit" disabled={validation.isSubmitting}>
                        {validation.isSubmitting ? 'Redefinindo a Palavra-Passe...' : 'Redefinir Palavra-Passe'}
                      </button>
                    </div>
                  </Form>

                  <div className="mt-5 text-center text-muted">
                    <p>
                      Lembrou-se da sua palavra-passe ?{" "}
                      <Link
                        to="/auth-signin-basic"
                        className="fw-medium text-decoration-underline"
                      >
                        {" "}
                        Entrar
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg="12">
                <div className="text-center text-muted p-4">
                  <p className="mb-0">
                    &copy; {new Date().getFullYear()} Khozi. Desenvolvido pela{" "}
                    <a
                      href="http://casco.co.mz/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      CASCO
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword1;
